import React from 'react';
import { translations } from '../translations';
import { FaRobot, FaChartLine, FaSyncAlt, FaBoxes, FaPeopleCarry, FaProjectDiagram } from 'react-icons/fa';

const Features = ({ language }) => {
    const features = [
        {
            icon: <FaRobot />,
            title: translations[language]['features.1.title'],
            desc: translations[language]['features.1.desc']
        },
        {
            icon: <FaChartLine />,
            title: translations[language]['features.2.title'],
            desc: translations[language]['features.2.desc']
        },
        {
            icon: <FaSyncAlt />,
            title: translations[language]['features.3.title'],
            desc: translations[language]['features.3.desc']
        },
        {
            icon: <FaBoxes />,
            title: translations[language]['features.4.title'],
            desc: translations[language]['features.4.desc']
        },
        {
            icon: <FaPeopleCarry />,
            title: translations[language]['features.5.title'],
            desc: translations[language]['features.5.desc']
        },
        {
            icon: <FaProjectDiagram />,
            title: translations[language]['features.6.title'],
            desc: translations[language]['features.6.desc']
        }
    ];

    return (
        <section className="features" id="features">
            <div className="section-title">
                <h3 className="chinese-font">{translations[language]['features.title']}</h3>
                <p className="chinese-font">{translations[language]['features.subtitle']}</p>
            </div>
            <div className="features-grid">
                {features.map((feature, index) => (
                    <div className="feature-card" key={index}>
                        <div className="feature-icon">{feature.icon}</div>
                        <h4 className="chinese-font">{feature.title}</h4>
                        <p className="chinese-font">{feature.desc}</p>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Features;
